export default __webpack_public_path__ + "static/media/checkCircle.7402f5cd.svg";